import { Pipe } from '@angular/core';
import { isString, upperFirst } from '../utils/utils';
var CapitalizePipe = (function () {
    function CapitalizePipe() {
    }
    CapitalizePipe.prototype.transform = function (input, all) {
        if (all === void 0) { all = false; }
        if (!isString(input)) {
            return input;
        }
        if (!all) {
            return upperFirst(input.toLowerCase());
        }
        else {
            return input.toLowerCase()
                .split(' ')
                .map(function (value) { return upperFirst(value); })
                .join(' ');
        }
    };
    return CapitalizePipe;
}());
export { CapitalizePipe };
CapitalizePipe.decorators = [
    { type: Pipe, args: [{
                name: 'capitalize'
            },] },
];
/** @nocollapse */
CapitalizePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=capitalize.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/capitalize.pipe.js
// module id = 273
// module chunks = 103